import React from "react";
import DefaultButton from "../components/buttons/DefaultButton";
import AppLogo from "../components/Logo/AppLogo";
import { useNavigate } from "react-router-dom";
import icon from "../assets/User.png";

const AuthHeader = () => {
  const navigate = useNavigate();
  return (
    <nav className="app-nav w-full flex px-5 md:px-10">
      <div className=" w-full flex items-center justify-between">
        <div>
          <AppLogo className="md:w-32 w-20" />
        </div>
        <div className="flex">
          <DefaultButton
            className="h-8 flex items-center"
            onClick={() => navigate('/login')}
          >
            <img className="mr-3 w-3" src={icon} alt="" /> Log In
          </DefaultButton>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader;
